import { makeStyles } from '@material-ui/core/styles'

import type { Theme } from '@material-ui/core/styles'

export const businessPlaceInputStyles = makeStyles((theme: Theme) => ({
  box: {
    backgroundColor: theme.customColors.input.default.filled.background,
    padding: '10px',
    marginBottom: '10px',
  },

  nearByList: {
    listStyleType: 'none',
    margin: 0,
    padding: 0,
    '& > li': {
      listStyleType: 'none',
      padding: '0 0 10px',
    },
    '& > li:last-child': {
      padding: 0,
    },
  },
}))
